import { P2Medium as P2MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P2Medium typography style.
 */
export default function P2Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P2MediumStyle, sx)} />;
}
